<template>
    <div class="progress-container">
        <div class="progress-bar" v-if="!(current>total||current<0)">
            <p  class="step-iban" v-if="step._progress_bar_text">Je bent er bijna!</p>
            <div class="normal">
                <div class="fill" :style="{width:100*current/total+'%'}"></div>
            </div>
        </div>
        <div class="progress-bubble" v-if="!(current>total||current<0)">
            <div class="wave-container">
                <div class="wave" id="wave1">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 96" width="360" height="96">
                        <path fill="#00C882" fill-rule="evenodd"
                              d="M360.667 138.314 360.743 17.541C349.773 18.074 315.733 37.071 273.933 36.991 190.103 36.831 185.293-2.949 90.003-3.999 48.703-4.449 15.133 14.901-.022 15.56L-.101 134.837Z"/>
                    </svg>
                </div>
                <div class="wave" id="wave2">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 96" width="360" height="96">
                        <path fill="#00C882" fill-rule="evenodd"
                              d="M360.667 138.314 360.743 17.541C349.773 18.074 315.733 37.071 273.933 36.991 190.103 36.831 185.293-2.949 90.003-3.999 48.703-4.449 15.133 14.901-.022 15.56L-.101 134.837Z"/>
                    </svg>
                </div>
            </div>
            <div class="wave-fill" :style="{height:100*current/total+'%'}"></div>
            <div class="progress-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 30" width="32" height="30">
                    <path fill="#FFF" fill-rule="evenodd"
                          d="M30 13.979H17V9.974h13v4.005ZM17 27.997h11V15.982H17v12.015Zm3.34-25.4c.812-.816 2.22-.814 3.03 0a2.186 2.186 0 0 1 0 3.067c-.862.87-3.5 2.307-4.882 2.307-.286 0-.37-.064-.372-.066-.464-.483.876-3.951 2.224-5.309ZM15 13.978H2V9.974h13v4.005ZM4 27.997h11V15.982H4v12.015Zm4.63-25.4a2.123 2.123 0 0 1 1.516-.634c.57 0 1.108.225 1.514.633 1.348 1.358 2.688 4.826 2.222 5.31 0 0-.084.065-.37.065-1.382 0-4.02-1.438-4.882-2.307a2.186 2.186 0 0 1 0-3.068ZM30 7.97h-6.328c.454-.31.844-.619 1.116-.895a4.193 4.193 0 0 0 0-5.892c-1.566-1.578-4.298-1.58-5.866 0-.866.871-3.168 4.418-2.85 6.787h-.144c.316-2.369-1.984-5.916-2.85-6.787-1.568-1.58-4.3-1.578-5.866 0a4.195 4.195 0 0 0-.002 5.892c.274.276.664.585 1.118.895H2c-1.102 0-2 .9-2 2.003v5.006c0 .553.448 1.002 1 1.002h1v12.015C2 29.101 2.898 30 4 30h24c1.102 0 2-.9 2-2.003V15.982h1c.552 0 1-.449 1-1.002V9.974a2.005 2.005 0 0 0-2-2.003Z"/>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import gsap from "gsap";
import store from "../../../store";
import mixin from "../../../components/form/steps/travel_step_mixin";

export default {
    mixins: [mixin],
    computed: {
        total() {
            return _.size(this.$store.get('form/form@_steps')) - 1
        },
        current() {
            return _.size(this.$store.get('general_data/steps_track')) - 1
        }
    },
    methods: {
        passed(step) {
            return step <= this.current
        }
    },
    mounted() {
        let tl = gsap.timeline({repeat: -1})
        tl.to('#wave1',{x:-50, duration:1.7, ease:'linear'})
        tl.to('#wave2',{x:-50, duration:1.7, ease:'linear'}, "<")

    }
}
</script>

<style lang="scss" scoped>


</style>
